import { AgxRow } from '@urbanx/agx-ui-components'
import './MobileHeader.scss'
import AutoPilotIconWithText from 'components/sidebar/icons/autoPilotIconWithText'

interface Props {
  isMenuCollapsed: boolean
  setIsMenuCollapsed: (value: boolean) => void
}

const MobileHeader = (props: Props) => {
  const { isMenuCollapsed, setIsMenuCollapsed } = props
  return (
    <AgxRow fill extraClasses="mobileHeaderContainer" centered spaceBetween>
      <AutoPilotIconWithText />
      <div
        className={`toggleMenuBtn ${isMenuCollapsed ? '' : 'open'}`}
        onClick={() => setIsMenuCollapsed(!isMenuCollapsed)}
      >
        <div className="line"></div>
        <div className="line"></div>
        <div className="line"></div>
      </div>
    </AgxRow>
  )
}

export default MobileHeader
